import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Subaward T&C Assignment: The association(s) between subaward and term/condition.',
    name: 'Subaward T&C Assignments',
    partialId: PartialId.Standard.create('subaward_tc_assign'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
